export async function getPriceRequests(token, params = {}) {
    const query = new URLSearchParams();
    if (params.page !== undefined) query.append("page", params.page);
    if (params.size !== undefined) query.append("size", params.size);
    if (params.status) query.append("status", params.status);
    if (params.supplierId) query.append("supplierId", params.supplierId);
    if (params.productId) query.append("productId", params.productId);
    if (params.search) query.append("search", params.search);

    try {
        const response = await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/price-requests?${query}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (response.ok) {
            return { success: true, data: await response.json() };
        } else {
            return { success: false, status: response.status };
        }
    } catch (error) {
        return { success: false, message: error.message };
    }
}

export async function getPriceRequestById(token, id) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/price-requests/${id}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (response.ok) {
            return { success: true, data: await response.json() };
        } else {
            return { success: false, status: response.status };
        }
    } catch (error) {
        return { success: false, message: error.message };
    }
}

export async function approvePriceRequest(token, id) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/price-requests/${id}/approve`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (response.ok) {
            return { success: true, data: await response.json() };
        } else {
            return { success: false, status: response.status };
        }
    } catch (error) {
        return { success: false, message: error.message };
    }
}

export async function rejectPriceRequest(token, id, rejectReason) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/price-requests/${id}/reject`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ rejectReason }),
            }
        );
        if (response.ok) {
            return { success: true, data: await response.json() };
        } else {
            return { success: false, status: response.status };
        }
    } catch (error) {
        return { success: false, message: error.message };
    }
}